import { render, staticRenderFns } from "./AdminProductEdit.vue?vue&type=template&id=c015dca8&scoped=true&"
import script from "./AdminProductEdit.vue?vue&type=script&lang=js&"
export * from "./AdminProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductEdit.vue?vue&type=style&index=0&id=c015dca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c015dca8",
  null
  
)

export default component.exports